import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaginatedResults } from '../../models/paginated_results_model';
import { PaginationOptions } from '../../models/pagination_options';
import { getCurrentApiDomain } from '../../helpers/helper-functions';

@Injectable({
  providedIn: 'root',
})
export class TariffCodeService {
  apiUrl = getCurrentApiDomain('/general');

  constructor(private http: HttpClient) { }

  search(paginationOptions: PaginationOptions) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<PaginatedResults>(
      this.apiUrl +
      `/search-tariff-codes?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }

}
